<template>
  <div class="d-flex align-items-center justify-content-between pdt-15 pdb-15 pdl-26 pdr-24">
    <div class="d-flex align-items-center">
      <i class="material-icons mgr-6 t-color-iconInactive font-22 mgr-32 min-w-22" v-html="lessonIcon"></i>
      <div class="t-body3 t-color-headlineBlack font-r l-spacing45 t-line-1 t-line-h-20 max-w-720" >{{ lessonName }}</div>
    </div>
    <slot name="detailInfo" class="d-flex align-items-center"></slot>
  </div>
</template>

<script>
export default {
  name: "LessonTab",

  props: {
    lessonName: String,
    lessonIcon: String
  },

  data() {
    return {}
  },

  mounted() {
  },
}
</script>

<style scoped>
.max-w-720{
  max-width: 720px;
}
</style>
